/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { useParams } from 'react-router-dom';
import { Row, Space, Col } from 'antd';
import { useUpdateEffect } from 'react-use';

import { FULL_WIDTH } from '@constants';
import { SORT_OPTIONS, DEFAULT_SORT } from '@api/constants';

import ArticleTagSelect from '../ArticleTagSelect';
import ArticleSelect from '../ArticleSelect';
import TableSelect from '../TableSelect';

const ArticlesByTag = ({ onChange, onClear, gutter = 20, ...props }) => {
  const [tag, setTag] = React.useState();
  const [sort, setSort] = React.useState();
  const { locale } = useParams();
  // do article cleanup when tag changed
  useUpdateEffect(() => {
    // eslint-disable-next-line no-unused-expressions
    onClear?.();
  }, [tag]);

  return (
    <Space size={gutter} direction="vertical" style={FULL_WIDTH}>
      <Row gutter={gutter}>
        <Col span={18}>
          <ArticleTagSelect style={FULL_WIDTH} onChange={setTag} />
        </Col>
        <Col span={6}>
          <TableSelect options={SORT_OPTIONS} defaultValue={DEFAULT_SORT.key} onSelect={setSort} />
        </Col>
      </Row>
      <ArticleSelect
        style={FULL_WIDTH}
        disabled={!tag}
        queryVariables={{ sort, tag: tag?.id, language: locale }}
        onChange={onChange}
        {...props}
      />
    </Space>
  );
};

export default ArticlesByTag;
